import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import _get from 'lodash/get';
// import FeaturedResources from '../components/HomeHeroReferral/FeaturedResources';
import Intro from './Intro';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundImage: ({ large }) => `url(${large})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      backgroundImage: ({ large, medium }) => `url(${medium || large})`,
    },
    [theme.breakpoints.down('xs')]: {
      backgroundImage: ({ large, medium, small }) =>
        `url(${small || medium || large})`,
      alignItems: 'flex-start',
    },
  },
  container: {
    [theme.breakpoints.up('1140')]: {
      width: 1140,
      padding: 0,
    },
    width: '100%',
    padding: '24px 5%',
  },
}));

function HomeHeroReferral({ item }) {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const objectImages = {
    large: _get(item, 'homeHeroImage.splashLarge.url'),
    medium: _get(item, 'homeHeroImage.splashMedium.url'),
    small: _get(item, 'homeHeroImage.splashSmall.url'),
  };
  const classes = useStyles(objectImages);
  let justify;
  switch (_get(item, 'copy.styles.align')) {
    case 'center':
      justify = 'center';
      break;
    case 'right':
      justify = 'flex-end';
      break;
    default:
      justify = 'flex-start';
      break;
  }
  if (isXs) {
    justify = 'center';
  }

  return (
    <div className={classes.root}>
      <Grid container className={classes.container} justifyContent={justify}>
        <Intro slug={item.slug} copy={item.copy} />
      </Grid>
    </div>
  );
}

HomeHeroReferral.propTypes = {
  // heroStyle: PropTypes.string,
  item: PropTypes.object,
};

export default HomeHeroReferral;
